<template>
  <div am-error-panel>
    <i-alert color="danger">
      <template #icon>
        <i-icon name="ink-danger" />
      </template>
      <p>Validation Errors</p>
    </i-alert>
    <div am-errors-list class="_border-right _border-color:danger">
      <i-list-group>
        <i-list-group-item v-for="(parts, id) in errors" :key="id">
          <template v-for="item in parts" :key="item">
            <h5 v-if="!item.name">Row #{{parts.rowIndex + 1}}</h5>
            <a
              v-else
              @click.prevent="showErrorPart(item)"
              href="#"
            >
              {{ item.name }} - {{ item.message }}
            </a>
          </template>
        </i-list-group-item>
      </i-list-group>
    </div>
    <div am-gradient="bottom" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'TheErrorPane',
  props: {
    errors: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations('ui', ['setErrorPart']),
    showErrorPart (item) {
      this.setErrorPart({ rowIndex: item.rowIndex, colIndex: item.colIndex, index: item.index })

      const cell = document.querySelectorAll('div[am-cell]')[item.index]
      // TODO: test in safsri
      cell.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
    }
  }
}
</script>

<style lang="scss">
.-dark {
  [am-error-panel] { background-color: var(--color--dark); }
}
.-light {
  [am-error-panel] { background-color: var(--color--white); }
}
[am-error-panel] {
  min-width: 20rem;
  [am-errors-list] {
    overflow-y: scroll;
    height: calc(100% - 56px);

    a { display: block; }
  }
  [am-gradient~=bottom] {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 10px;
  }
}
</style>
